<mat-card class="chart-card">
  <mat-card-header class="chart-header">
    <mat-card-title>
      {{ "All MDB Power (kW) - Today" | translate }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="power-chart" echarts [options]="chartOption"></div>
  </mat-card-content>
</mat-card>
